import { supabase } from '../lib/supabase';

export async function uploadImage(file) {
  const ext      = file.name.split('.').pop();
  const filename = `${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  const { error } = await supabase.storage
    .from('project-images')
    .upload(filename, file, { cacheControl: '3600', upsert: false });

  if (error) throw new Error(error.message);

  const { data } = supabase.storage.from('project-images').getPublicUrl(filename);
  return data.publicUrl;
}

export async function uploadDownloadFile(file) {
  // 원본 파일명 보존 (공백 → 하이픈, 특수문자 제거)
  const safeName = file.name
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9._-]/g, '');
  // project-images 버킷의 downloads/ 하위 폴더 사용 (기존 RLS 정책 재사용)
  const path = `downloads/${Date.now()}-${safeName}`;

  const { error } = await supabase.storage
    .from('project-images')
    .upload(path, file, { cacheControl: '3600', upsert: false });

  if (error) throw new Error(error.message);

  const { data } = supabase.storage.from('project-images').getPublicUrl(path);
  return { url: data.publicUrl, name: file.name };
}

export async function fetchAllProjectsAdmin() {
  const { data, error } = await supabase
    .from('projects')
    .select('id, title, project_type, tags, role, project_date, is_visible, is_main_only, thumbnail_url')
    .order('project_date', { ascending: false });
  if (error) { console.error('[adminService] fetchAll:', error); return []; }
  return data || [];
}

export async function fetchProjectWithSectionsAdmin(id) {
  const { data, error } = await supabase
    .from('projects')
    .select(`
      id, title, project_type, tags, role, project_date, thumbnail_url, mobile_thumbnail_url,
      is_visible, is_main_only, external_url, link_type,
      work_period, work_type, contribution, tools, link_url,
      project_sections(id, section_type, title, content, image_url, extra_images, background_color, order_index, is_visible, downloadable, video_url, text_size, text_weight)
    `)
    .eq('id', id)
    .single();
  if (error) { console.error('[adminService] fetchOne:', error); return null; }
  return data;
}

export async function saveProjectAdmin(projectData, sections) {
  let projectId = projectData.id;

  if (projectId) {
    const { id, ...updateData } = projectData;
    const { error } = await supabase.from('projects').update(updateData).eq('id', id);
    if (error) throw error;
  } else {
    const { data, error } = await supabase
      .from('projects').insert(projectData).select('id').single();
    if (error) throw error;
    projectId = data.id;
  }

  await supabase.from('project_sections').delete().eq('project_id', projectId);
  if (sections.length > 0) {
    const { error } = await supabase
      .from('project_sections')
      .insert(sections.map((s) => ({ ...s, project_id: projectId })));
    if (error) throw error;
  }

  return projectId;
}

export async function deleteProjectAdmin(id) {
  const { error } = await supabase.from('projects').delete().eq('id', id);
  if (error) console.error('[adminService] delete:', error);
}

export async function toggleProjectVisibilityAdmin(id, isVisible) {
  const { error } = await supabase
    .from('projects').update({ is_visible: isVisible }).eq('id', id);
  if (error) throw new Error(error.message);
}

// ── Home Featured ─────────────────────────────────────────────────────────────

export async function fetchFeaturedAdmin() {
  const { data, error } = await supabase
    .from('home_featured_projects')
    .select('id, project_id, is_visible, order_index, button_label, button_url, button_target, projects(id, title, project_type, thumbnail_url, is_visible, is_main_only)')
    .order('order_index', { ascending: true });
  if (error) { console.error('[adminService] fetchFeaturedAdmin:', error); return []; }
  return data || [];
}

export async function addToFeatured(projectId) {
  const { data: existing } = await supabase
    .from('home_featured_projects').select('order_index').order('order_index', { ascending: false }).limit(1);
  const nextOrder = (existing?.[0]?.order_index ?? -1) + 1;
  const { error } = await supabase.from('home_featured_projects').insert({
    project_id: projectId, order_index: nextOrder, is_visible: true, button_label: 'View Project',
  });
  if (error) throw new Error(error.message);
}

export async function removeFromFeatured(id) {
  const { error } = await supabase.from('home_featured_projects').delete().eq('id', id);
  if (error) throw new Error(error.message);
}

export async function updateFeatured(id, fields) {
  const { error } = await supabase.from('home_featured_projects').update(fields).eq('id', id);
  if (error) throw new Error(error.message);
}

export async function batchUpdateFeaturedOrder(items) {
  await Promise.all(items.map(({ id, order_index }) =>
    supabase.from('home_featured_projects').update({ order_index }).eq('id', id)
  ));
}
